import { useEffect, useRef, useState } from "react";
import PinInput from 'react-pin-input';
import { toast } from "react-toastify";
import { ButtonLoader } from "./form";
import Maybe from "./Maybe";
import { useDispatch, useSelector } from "react-redux";
import * as settingsAction from "store/entities/settingsInfo/action";




const TwoFactorPinModal = (props) => {
    const {isOpenPin, setIsOpenPin, active2fa, setActive2fa, switchModalContent, getEmployerInfo} = props;
    const resetAccessPinRef = useRef();
    const dispatch = useDispatch();

    
    
    const { changeTwoFactorAuthStatus, changeTwoFactorAuthStatusLoading: loading} = useSelector((state) => state.entities.settingsInfo);
    
    const [is2faModalOpen, setIs2faModalOpen] = useState(false)
    const pinLength = 4;
    const [pin, setPin] = useState("");
    let elementRef = useRef();
    

    const handle2faOtp = async (e, bool) => {
        e.preventDefault();
        if (pin !== "" && pin.length === pinLength){
                // clearInputPin();
            dispatch(settingsAction.changeTwoFactorAuthStatus({twoFactorAuth: bool, otp: +pin}))
            // getEmployerInfo()
            setIs2faModalOpen(true)
            // setIsOpenPin(false)
        }
        else{
            toast.error("Please enter a valid pin");
            // toast.error("Please enter a valid " + props.target);
        }
    }

    const clearInputPin =() => {
        if (elementRef.currentIndex !== undefined){
            elementRef.clear();
            setPin("");
        }
    }

    useEffect(() => {
        clearInputPin();
    }, [isOpenPin]);
    
    
    useEffect(() => {
        if(is2faModalOpen && changeTwoFactorAuthStatus?.error === false){
            // toast(changeTwoFactorAuthStatus?.message)
            getEmployerInfo()
            setIs2faModalOpen(false)
            setIsOpenPin(false)
            switchModalContent('2faConsent')
            clearInputPin();
            // setActive2fa(changeTwoFactorAuthStatus?.data?.twoFactorAuth)
        }
    //     // eslint-disable-next-line
    }, [changeTwoFactorAuthStatus, is2faModalOpen, setActive2fa]);
    
  return (
    <>
        <div className="h-16 mt-14">
                            <PinInput 
                                length={pinLength} 
                                initialValue={pin}
                                // onChange={(value, index) => {setPin(value); props.pin(value)}} 
                                onChange={(value, index) => {setPin(value); props.pin && props.pin(value)}} 
                                type="numeric" 
                                inputMode="number"
                                inputStyle={{
                                    width: '50px',
                                    border: "2px solid #e5e7eb",
                                    fontSize: "28px",
                                    borderRadius: "10px",
                                    paddingTop: "2px"
                                }}
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                }}
                                secretDelay={300}
                                inputFocusStyle={{border: "2px solid #e5e7eb"}}
                                onComplete={(value, index) => {}}
                                autoSelect={true}
                                focus={true}
                                secret={true}
                                ref={(n) => (elementRef = n)}
                            />
                        </div>
                        <Maybe condition={props.showForgotPin === true}>
                            <div className="mt-2 flex justify-end">
                                <div onClick={() => {setIsOpenPin(false); resetAccessPinRef.current?.initiateResetPin()}} className="text-ep-primary-600 font-medium underline cursor-pointer">
                                    Forgot Pin?
                                </div>
                            </div>
                        </Maybe>

                        <Maybe condition={props.footnote !== undefined}>
                            <div className="mt-2 relative top-6">
                                {props.footnote}
                            </div>
                        </Maybe>

                        <div className="mt-10 flex space-x-4 justify-end">
                            <button type="button" onClick={() => {setIsOpenPin(false); switchModalContent('2faConsent')}} className="btn 'btn-transparent-primary">
                                Cancel
                            </button>
                            {active2fa === true ? 
                            <ButtonLoader loading={loading} onClick={(e) => handle2faOtp(e, false)} className="btn btn-ep-danger-500"> 
                                Disable
                            </ButtonLoader>
                            : 
                            <ButtonLoader loading={loading} onClick={(e) => handle2faOtp(e, true)} className="btn btn-ep-primary"> 
                                Enable
                            </ButtonLoader>
                            }
                            
                        </div> 
    </>
  )
}

export default TwoFactorPinModal